import React from 'react';
import me from '../../images/me.png'
import HeroText from './HeroText';


const Hero = () => {
    return (
      
<div style={{
            backgroundImage: "url('https://vproduction.com/wp-content/themes/vprod/assets/img/svg/menu-background.svg')",
  backgroundPosition: 'center',
  backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                
        }} >
        <div id='home' className="grid mt-20 lg:grid-cols-2 lg:mt-0 items-center h-screen mx-12 justify-between">
                <div className=''>
                  
                    <p className='text-2xl font-light'>HAY THERE</p>
             <HeroText></HeroText>
                {/* <h1 className='sm:text-xl md:text-3xl lg:text-5xl font-black'>I'M SHAHIDUL ISLAM</h1> */}
                <h4 className='text-2xl '>JUNIOR REACT FRONTEND DEVELOPER</h4>
                <a href="ResumeofSHAHIDULISLAM.pdf" download>
                        <button class="btn btn-primary hover:bg-indigo-600 py-2 px-2 rounded font-semibold text-white mt-5">
                
                         GET RESUME <span className='mx-2  p-2 rounded-full bg-[#4F4EE5] opacity-60	'>📑</span>
</button>
                </a>

            </div>
            <div className='w-[70%] h-[70%] mx-auto' >
                <img className='sm:ml-0' src={me} alt="" />
            </div>
            </div>
            </div>

    
    );
};

export default Hero;